// OBSOLETE, TODO: refactor out all of the types
//import { QuizSession } from '@/app/database/database-models';
import { TranslateResult } from 'vue-i18n';
import {
  SerializedSearchIndex,
  SerializedCompetence,
  // SerializedScenario,
  // SerializedFillIn,
  // SerializedHotspot,
  SerializedAspectValueDescriptor
} from '@xlearn/common';

export interface Course {
  id: string;
  version: string;
  date: string;
  defaultAspectId: string;
  aspects: Aspect[];
}

export interface Aspect {
  id: string;
  name: string;
  instances: AspectInstance[];
}

export interface AspectInstance {
  id: string;
  aspectValue: string;
  courseTitle: string;
  courseSubtitle?: string;
  courseDescription: string;
  courseIconUri?: string|null;
  courseImageUri?: string|null;
  files: CourseFiles;
  finalQuizId: string|null;
  sectionImageUri: string|undefined;
  sectionBackgroundUri: string|undefined;
  time?: {
    seconds: number;
    human: string;
  };
  revisionDate: string | undefined;
  revisionNumber: string | undefined;
}

export interface AspectSelectInfo {
  level: number;
  name: string;
  values: SerializedAspectValueDescriptor[];
}

export interface CourseAspect {
  courseId: string;
  language: string;
  title: string;
  subtitle: string;
  description: string;
  iconUri: string|null;
  imageUri: string;
  tocItems: TocItem[];
  // OBSOLETE
//  questions: Question[];
  // OBSOLETE
//  quizzes: Quiz[];
//  finalQuizId: string|null;
  basePath: string;
  files: File[];
  terms: Term[];
  search: SerializedSearchIndex;
  competences: SerializedCompetence[];
  sectionImageUri: string|null;
  sectionBackgroundUri: string|null;
  pdfUri: string|null;
  time: {
    seconds: number;
    human: string;
  }|null;
  revisionDate: string | null;
  revisionNumber: string | null;
  authors: Author[];
  preamble: string | null;
}

export interface Author {
  name: string
  email: string | undefined
}

export interface CourseFiles {
  tocUri: string;
  questionBankUri: string;
  quizBankUri: string;
  fileBankUri: string;
  termBankUri: string;
}

export interface TocItem {
  id: string;
  title: string;
  type: string;
  href: string|null;
  percent?: number;
  imageUri?: string;
  backgroundUri?: string;
  children?: TocItem[];
  time?: {
    seconds: number;
    human: string;
  };
}

export interface IntroLink {
  uri: string;
  query: any;
  title: string;
  percent: number;
}

// // OBSOLETE
// interface Quiz {
//   id: string;
//   title: string;
//   allowedModes: QuizMode[];
//   feedbacks: { [mode: string]: QuizFeedback };
//   description: { [mode: string]: string };
//   options: QuizOptions;
//   examOptions: ExamOptions|null;
//   questions: { [mode: string]: QuizQuestion[] };
// }

// export interface QuizQueryResult {
//   quiz: Quiz|null;
//   recentSession: QuizSession|null;
// }

// enum QuizMode {
//   practice = 'practice',
//   exam = 'exam'
// }

// interface QuizFeedback {
//   success: string;
//   fail: string;
// }

// export interface QuizOptions {
//   questionCount: number;
//   percentToPass: number;
// }

// export interface ExamOptions {
//   timeLimitSeconds: number;
//   attemptsAllowed: number;
//   gradingMethod: GradingMethod;
//   reviewOptions: ReviewOptions|null;
// }

// export interface ReviewOptions {
//   whetherCorrect: boolean;
//   rightAnswer: boolean;
// }

// export enum GradingMethod {
//   highestGrade = 'highestGrade',
//   lastAttempt = 'lastAttempt'
// }

// export interface QuizQuestion {
//   questionId: string;
//   question?: Question;
//   level: QuestionLevel;
//   score: number;
//   topics: string[];
//   competences: string[];
//   state?: QuizQuestionState;
//   minScore: number;
//   maxScore: number;
// }

// export enum QuestionLevel {
//   easy = 'easy',
//   normal = 'normal',
//   hard = 'hard'
// }

// export enum QuizQuestionState {
//   answeredButNotEvaluated = 0,
//   notAnswered = 1,
//   correct = 2,
//   incorrect = 3,
//   partiallyCorrect = 4,
//   disabled = 5
// }

// export interface Question {
//   id: string;
//   question: string;
//   type: QuestionType;
//   content: QuestionContent|SerializedScenario|SerializedFillIn|SerializedHotspot;
//   feedback: QuestionFeedback;
//   level: QuestionLevel;
//   score: number;
//   /*minScore: number;
//   maxScore: number;*/
// }

// /** @deprecated */
// export enum QuestionType {
//   choice = 'choice',
//   sorting = 'sorting',
//   grouping = 'grouping',
//   matching = 'matching',
//   shortAnswer = 'shortAnswer',
//   scenario = 'scenario',
//   fillIn = 'fillIn',
//   hotspot = 'hotspot',
//   unknown = 'unknown'
// }

// /** @deprecated */
// export interface QuestionContent {
//   answers?: Answer[];
//   groups?: GroupingAnswer[];
//   pairs?: MatchingPair[];
//   questions?: ShortQuestion[];
// }

// /** @deprecated */
// export interface Answer {
//   id: string;
//   answer: string;
//   score: number|QuestionScore;
// }

// /** @deprecated */
// export interface GroupingAnswer {
//   id: string;
//   label: string;
//   members: GroupingAnswerMember[];
// }

// /** @deprecated */
// export interface GroupingAnswerMember {
//   id: string;
//   text: string;
//   score: QuestionScore;
// }

// /** @deprecated */
// export interface MatchingPair {
//   id: string;
//   first: string;
//   second: string;
//   score: QuestionScore;
// }

// /** @deprecated */
// export interface ShortQuestion {
//   id: string;
//   question: string;
//   incorrectScore: number;
//   answers: SortQuestionAnswer[];
// }

// /** @deprecated */
// export interface SortQuestionAnswer {
//   id: string;
//   answer: string;
//   score: number;
// }

// /** @deprecated */
// export interface QuestionScore {
//   correct: number;
//   incorrect: number;
// }

// /** @deprecated */
// export interface QuestionFeedback {
//   correct?: string;
//   incorrect?: string;
//   tryAgain?: string;
// }

// /** @deprecated */
// export interface QuestionAnswerBase {
//   correct: boolean;
//   score: number;
// }

// /** @deprecated */
// export interface ChoiceQuestionAnswer extends QuestionAnswerBase {
//   answerIds: string[];
// }

// /** @deprecated */
// export interface GroupingQuestionAnswer extends QuestionAnswerBase {
//   groupMembers: { [groupId: string]: string[] };
// }

// /** @deprecated */
// export interface SortingQuestionAnswer extends QuestionAnswerBase {
//   answerIdsOrder: string[];
// }

// /** @deprecated */
// export interface MatchingQuestionAnswer extends QuestionAnswerBase {
//   pairs: MatchingQuestionAnswerItem[];
//   concepts: any[];
//   definitions: any[];
// }

// /** @deprecated */
// export interface MatchingQuestionAnswerItem {
//   firstId: string;
//   firstIndex: number;
//   secondId: string;
//   secondIndex: string;
// }

// /** @deprecated */
// export interface ShortAnswerQuestionAnswer extends QuestionAnswerBase {
//   answers: { [questionId: string]: string };
// }

// /** @deprecated */
// export interface FillInQuestionAnswer extends QuestionAnswerBase {
//   answers: { [gapId: string]: string };
// }

// export interface HotspotQuestionAnswer extends QuestionAnswerBase {
//   answers: { [index: number]: boolean };
// }

// /** @deprecated */
// export interface QuestionAnswer {
//   questionId: string;
//   answer: any|null;
//   correct: boolean;
//   score: number;
//   evaluated: boolean;
//   hideSolutionButton?: boolean;
//   hideEvalTitle?: boolean;
// }

// /** @deprecated */
// export interface QuizAnswer extends QuestionAnswer {
//   timeSpent: number;
// }

export interface Dashboard {
  courseTitle: string;
  courseSubtitle: string;
  courseDescription: string;
  courseImageUri: string|null;
  totalReadingTime: string|null;
  courseProgress: any; // TODO
  questionsProgress: any; // TODO
  chapterProgressItems: ChapterProgress[];
  competencePercents: { [name: string]: number };
  competenceTotalPercent: number;
  revisionDate: string | null;
  revisionNumber: string | null;
  authors: Author[];
  preambleContent: string | null;
}

/*export interface Progress {
  totalPercent: number;
  recentPercent: number;
}*/

export interface ChapterProgress {
  id: string;
  index: number;
  title: string;
  href: string;
  imageUri: string|null;
  sectionsCount: string;
  readingTime: string|null;
  progressPercent: number;
  lastActivityTimestamp: string|null;
}

export interface SelectOption {
  value: number|string;
  label: string;
  percent: number;
}

export interface DropdownItem {
  id: string;
  label: string|TranslateResult;
}

export interface Link {
  href: string|null;
  title: string;
}

export enum SortType {
  recent = 'recent',
  index = 'index'
}

export interface File {
  title: string;
  originalFilename: string;
  mimeType: string;
  description: string|null;
  size: string;
  uri: string;
  topicIds: string[];
}

export interface Term {
  id: string;
  title: string;
  content: string;
  topicIds: string[];
}

// /** @deprecated */
// export interface HotspotItem {
//   x: number;
//   y: number;
//   content: string;
// }

// /** @deprecated */
// export interface FlipcardItem {
//   label: string;
//   content: string;
// }

// /** @deprecated */
// export interface AccordionItem {
//   label: string;
//   content: string;
// }

// /** @deprecated */
// export interface ClickImageItem {
//   imageUri: string;
//   title: string|null;
//   content: string;
// }

// /** @deprecated */
// export interface GalleryItem {
//   imageSrc: string;
//   title: string|null;
//   content: string;
// }

// /** @deprecated */
// export interface QuestionIsAnimated {
//   [questionId: string]: boolean;
// }

// export interface Coordinate {
//   x: number;
//   y: number;
// }
